import React from 'react';
import { graphql, Link } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';

const ModularHeadingContentImageButton = ({ data }) => {
  const {
    backgroundColor,
    buttonPath,
    buttonText,
    heading,
    content,
    noBottomPadding,
    noTopPadding,
    rowReverse,
    textAlign,
    featureImageDesktop,
    isButtonUnderline,
  } = data;
  return (
    <div className="modular-header-content-image-button-container">
      <div
        className={`${backgroundColor} ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        } `}
      >
        <div className={`modular-header modular-global-width`}>
          <div
            className={`${
              rowReverse
                ? 'image-header-paragraph-inner-reverse'
                : 'image-header-paragraph-inner'
            } `}
          >
            {/* PurgeCSS include: Left, Right, Centre, default-align*/}
            <div className={`content-container`}>
              <div
                className={`${textAlign && textAlign} ${
                  !textAlign && 'default-align'
                }`}
              >
                <div className="modular-heading-third modular-heading-secondary">
                  <LitStructuredText data={heading} basic />
                </div>
                <div className="content modular-p">
                  {content && <LitStructuredText data={content} basic />}
                </div>
                {/* PurgeCSS include: Yellow-button-underline, White-button-underline, Black-button-underline */}
                <Link
                  to={buttonPath}
                  className={`${
                    isButtonUnderline
                      ? `${backgroundColor}-button-underline`
                      : 'button'
                  }`}
                >
                  {buttonText}
                </Link>
              </div>
            </div>
            <div className="image-container">
              <LitImage image={featureImageDesktop} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModularHeadingContentImageButton;
export const fragment = graphql`
  fragment ModularHeadingContentImageButton on DatoCmsHeadingContentImageButtonBlock {
    internal {
      type
    }
    backgroundColor
    buttonPath
    buttonText
    heading {
      value
    }
    content {
      value
    }
    isButtonUnderline
    noBottomPadding
    noTopPadding
    rowReverse
    textAlign
    featureImageDesktop {
      gatsbyImageData
    }
  }
`;
